/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Ismicenabledbydefault4Inputs */

const en_entity_ismicenabledbydefault4 = /** @type {(inputs: Entity_Ismicenabledbydefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Mic Enabled By Default`)
};

const de_entity_ismicenabledbydefault4 = /** @type {(inputs: Entity_Ismicenabledbydefault4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikrofon standardmäßig aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Mic Enabled By Default" |
*
* @param {Entity_Ismicenabledbydefault4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_ismicenabledbydefault4 = /** @type {((inputs?: Entity_Ismicenabledbydefault4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Ismicenabledbydefault4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ismicenabledbydefault4(inputs)
	return de_entity_ismicenabledbydefault4(inputs)
});
export { entity_ismicenabledbydefault4 as "entity_isMicEnabledByDefault" }